import {Calendar} from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {compose} from 'redux';
import ChangeMonthDayStatus from './ChangeMonthDayStatus';
import withAuthorization from '../../../services/Authorization';
import Constants from '../../../services/Constants';
import Time from '../../../services/Time';

class MonthConfigurationTab extends React.Component {

  static propTypes = {
    dispatchFetchMonthlyPlanning: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      dayStatusModalOpen: false,
      monthDays: {},
      selectedDayInformation: {}
    }
  };

  onCalendarRangeChange = (date) => {
    if (moment(this.props.selectedDay).year() !== moment(date).year()) {
      this.props.dispatchFetchMonthlyPlanning(moment(date).format(Constants.DATE_FORMAT_API));
    }
    this.props.updateSelectedDay(date);
  };

  onModalDayChange = (day, data) => {
    this.props.updateDay(day, data);
  };

  onSelectDate = (date) => {
    if (Time.beforeToday(date)) {
      return; // do not select past day
    }
    this.setState({
      dayStatusModalOpen: true,
      selectedDayInformation: this.state.monthDays[moment(date).format(Constants.DATE_FORMAT_API)]
    });
  };

  computeCellColor = (day, maxInterventions, dayStatus, amStatus, pmStatus) => {
    const {computeAll} = this.props;
    const totalOngoing = computeAll(moment(day).format(Constants.DATE_FORMAT_API));

    if (Time.beforeToday(day)) {
      return "calendar-box--expired";
    }
    if (dayStatus === Constants.DAY_OVERBOOKED.value && amStatus === Constants.DAY_BLOCK_AM.value && !pmStatus) {
      return "block-am-open-pm";
    }
    if (dayStatus === Constants.DAY_OVERBOOKED.value && !amStatus && pmStatus === Constants.DAY_BLOCK_PM.value) {
      return "open-am-block-pm";
    }
    if (dayStatus === Constants.DAY_MIXED.value && amStatus === Constants.DAY_BLOCK_AM.value && pmStatus === Constants.DAY_CLOSED_PM.value) {
      return "block-am-close-pm";
    }
    if (dayStatus === Constants.DAY_MIXED.value && amStatus === Constants.DAY_CLOSED_AM.value && pmStatus === Constants.DAY_BLOCK_PM.value) {
      return "close-am-block-pm";
    }
    if (dayStatus === Constants.DAY_CLOSED.value && amStatus === Constants.DAY_CLOSED_AM.value && !pmStatus) {
      return "close-am-open-pm";
    }
    if (dayStatus === Constants.DAY_CLOSED.value && !amStatus && pmStatus === Constants.DAY_CLOSED_PM.value) {
      return "open-am-close-pm";
    }
    if (dayStatus && dayStatus === Constants.DAY_CLOSED.value) {
      return "calendar-box--closed";
    }
    if (dayStatus && dayStatus === Constants.DAY_OVERBOOKED.value) {
      return "calendar-box--unavailable";
    }
    return (maxInterventions <= 0) ? "" : (totalOngoing >= maxInterventions) ? "calendar-box--full" : "calendar-box--available";
  };

  getBlockedData = (extendedStatus) => {
    switch (extendedStatus) {
      case Constants.DAY_CONSTRAINT_BLOCK_WAIT_AM.value:
      case Constants.DAY_CONSTRAINT_BLOCK_WAIT_PM.value:
        return 'W';
      case Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_AM.value:
      case Constants.DAY_CONSTRAINT_BLOCK_NON_WAIT_PM.value:
        return 'N-W';
      default:
        return null
    }
  }

  updateMonthDays = (day, maxInterventions, nbInterventions, dayStatus, amStatus, pmStatus, amExtendedStatus, pmExtendedStatus) => {
    const {monthDays} = this.state;
    const currentDay = monthDays[day] || {};

    if (currentDay.dayStatus !== dayStatus || currentDay.amStatus !== amStatus || currentDay.pmStatus !== pmStatus || currentDay.amExtendedStatus !== amExtendedStatus || currentDay.pmExtendedStatus !== pmExtendedStatus || currentDay.nbInterventions !== nbInterventions || currentDay.maxInterventions !== maxInterventions) {
      monthDays[day] = {day, maxInterventions, nbInterventions, dayStatus, amStatus, pmStatus, amExtendedStatus, pmExtendedStatus};
      this.setState({monthDays})
    }
  };

  dateFullCellRender = (day) => {
    const {data = {}, maxByWeekDay = {}} = this.props;
    const currentWeekDay = Time.dayOfWeekAsStringUppercase(day);

    const dataForDay = data[moment(day).format(Constants.DATE_FORMAT_API)] || {};

    const currentDay = moment(day).format("D");
    const maxInterventions = maxByWeekDay[currentWeekDay] || 0;
    const interventionsForDay = (Object.keys(dataForDay).length > 0) ? dataForDay.currentInterventions : 0;

    const colorClass = this.computeCellColor(day, maxInterventions, dataForDay.dayStatus, dataForDay.amStatus, dataForDay.pmStatus);
    this.updateMonthDays(moment(day).format(Constants.DATE_FORMAT_API), maxInterventions, interventionsForDay, dataForDay.dayStatus, dataForDay.amStatus, dataForDay.pmStatus, dataForDay.amExtendedStatus, dataForDay.pmExtendedStatus);

    return (
      <div className={colorClass + " ant-fullcalendar-date"}>
        <div className="cell">
          <div className="corner tl">
            {this.getBlockedData(dataForDay.amExtendedStatus)}
          </div>
          <div className="corner tr">
            {currentDay}
          </div>
          {colorClass.length > 0 &&
            <div className="metric">
              {interventionsForDay} / {maxInterventions}
            </div>
          }
          <div className="corner br">
            {this.getBlockedData(dataForDay.pmExtendedStatus)}
          </div>
        </div>
      </div>
    )
  };

  render() {
    const {selectedDay, planning} = this.props;
    return (
      <div>
        <Calendar
          className="calendar--hidden-year"
          onSelect={this.onSelectDate}
          dateFullCellRender={this.dateFullCellRender}
          onPanelChange={this.onCalendarRangeChange}
          value={moment(selectedDay)}
        />
        <ChangeMonthDayStatus
          visible={this.state.dayStatusModalOpen}
          onModalClose={() => this.setState({dayStatusModalOpen: false})}
          onModalDayChange={this.onModalDayChange}
          date={this.state.selectedDayInformation}
          planning={planning}
          computeAll={this.props.computeAll}/>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchMonthlyPlanning: (date) => dispatch({type: 'FETCH_MONTHLY_PLANNING.REQUEST', date})
});

export default compose(
  connect(undefined, mapDispatchToProps),
  injectIntl,
  (Component) => withAuthorization(Component, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR'])
)(MonthConfigurationTab);
